import React from 'react';

import logoText from 'assets/images/logo-text.svg';
import mainVisualImage from 'assets/images/main-visual.png';

function MainVisual() {
  return (
    <section className="visual">
      <span className="side-logo">
        <img src={logoText} alt="" />
      </span>
      <div className="main-text">
        <img src={mainVisualImage} alt="" />
      </div>
    </section>
  );
}

export default MainVisual;
